import { StrictMode } from 'react'
import './i18n'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

if (typeof window !== 'undefined') {
  const rootEl = document.getElementById('root')!
  if (import.meta.env.DEV) {
    createRoot(rootEl).render(app)
  } else {
    hydrateRoot(rootEl, app)
  }
}

/** ビルド時プリレンダ（vite-prerender-plugin）— クライアントの見た目・文言はそのまま HTML 化 */
export async function prerender(data: { url: string }) {
  const { renderToString } = await import('react-dom/server')
  const pathname = locationFromPrerenderUrl(data.url)
  const html = renderToString(
    <StrictMode>
      <App ssrPathname={pathname} />
    </StrictMode>
  )
  return { html }
}

function locationFromPrerenderUrl(url: string): string {
  try {
    const u = new URL(url)
    return u.pathname + u.search + u.hash
  } catch {
    return url.startsWith('/') ? url : `/${url}`
  }
}
